import type { Context } from 'node:vm'
import { ErrorMessage, Field, Form } from 'vee-validate'

export default defineNuxtPlugin((ctx: Context) => {
  ctx.vueApp.component('VForm', Form)
  ctx.vueApp.component('VField', Field)
  ctx.vueApp.component('VErrorMessage', ErrorMessage)
})
